import { createReducer } from "redux-create-reducer";

import {
  GET_MONITORING_QUEUE_ENTRIES,
  GET_SCORE_CARD_RISK_FACTORS,
  EXPORT_MONITORING_QUEUE,
  GET_MONITORING_QUEUE_ENTRIES_COUNT,
  SET_MONITORING_QUEUE_ENTRY_SEARCH_FILTERS,
  CLEAR_MONITORING_QUEUE_ENTRIES,
  SET_MONITORING_QUEUE_ENTRY_CURRENT_PAGE,
  SET_MONITORING_QUEUE_ENTRY_ITEMS_PER_PAGE,
  SET_MONITORING_QUEUE_TABLE_CHECKBOX_CHECKED,
  SET_TABLE_HEADER_DROPDOWN_VALUE,
  SET_SELECTED_ENTRIES,
  SET_DESELECTED_ENTRIES,
  SET_MONITORING_QUEUE_ENTRY_NO_ENTRIES_MESSAGE,
} from "../types";

import { TABLE_HEADER_DROPDOWN_VALUES } from "../constants/monitoringQueueEntryConstants";

const initialState = {
  data: [],
  exportEntries: [],
  riskFactors: [],
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  filters: {
    type: null,
    riskLevel: null,
    status: null,
    hasWatchListMatch: null,
    dateFrom: null,
    dateTo: null,
    clientType: null,
    clientName: "",
    clientNumber: "",
    clientOfferId: "",
    customClientParameters: [],
  },
  entries: [],
  monitoringQueueEntries: [],
  tableDropdownChecked: false,
  tableHeaderDropdownValue: TABLE_HEADER_DROPDOWN_VALUES.ON_THIS_PAGE,
  selectedEntries: [],
  deselectedEntries: [],
  isLoading: false,
  isExportLoading: false,
  noEntriesMessage: "",
  jobType: "",
  selectAllChecked: null,
};

const monitoringQueueEntriesReducer = createReducer(initialState, {
  [SET_MONITORING_QUEUE_ENTRY_SEARCH_FILTERS]: (state, { payload }) => {
    return {
      ...initialState,
      riskFactors: state.riskFactors,
      clientTypes: state.clientTypes,
      filters: {
        ...state.filters,
        ...payload,
        selectedEntries: null,
        deselectedEntries: null,
        jobType: "",
        selectAllChecked: null,
      },
    };
  },
  [SET_MONITORING_QUEUE_ENTRY_CURRENT_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [SET_MONITORING_QUEUE_ENTRY_ITEMS_PER_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [GET_MONITORING_QUEUE_ENTRIES_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MONITORING_QUEUE_ENTRIES_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MONITORING_QUEUE_ENTRIES_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_MONITORING_QUEUE_ENTRIES_COUNT.FULFILLED]: (state, { payload }) => {
    // const hasResults = payload.data > 0;
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: false,
    };
  },
  [EXPORT_MONITORING_QUEUE.DEFAULT]: (state) => ({
    ...state,
    isExportLoading: true,
  }),
  [EXPORT_MONITORING_QUEUE.PENDING]: (state) => ({
    ...state,
    isExportLoading: true,
  }),
  [EXPORT_MONITORING_QUEUE.REJECTED]: (state) => ({
    ...state,
    isExportLoading: false,
  }),
  [EXPORT_MONITORING_QUEUE.FULFILLED]: (state, { payload }) => {
    const fileName = payload.headers["content-disposition"]
      .split("filename=")[1]
      .split(";")[0];
    return {
      ...state,
      exportEntries: {
        fileBytes: new Blob([payload.data], { type: "text/csv" }),
        fileName,
      },
      isExportLoading: false,
    };
  },
  [GET_SCORE_CARD_RISK_FACTORS.DEFAULT]: (state) => ({
    ...state,
  }),
  [GET_SCORE_CARD_RISK_FACTORS.PENDING]: (state) => ({
    ...state,
  }),
  [GET_SCORE_CARD_RISK_FACTORS.REJECTED]: (state) => ({
    ...state,
  }),
  [GET_SCORE_CARD_RISK_FACTORS.FULFILLED]: (state, { payload }) => {
    let data = payload.data.map(function (d) {
      return { value: d.name, label: d.name };
    });
    return {
      ...state,
      riskFactors: data,
    };
  },
  [GET_MONITORING_QUEUE_ENTRIES.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MONITORING_QUEUE_ENTRIES.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MONITORING_QUEUE_ENTRIES.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_MONITORING_QUEUE_ENTRIES.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [SET_MONITORING_QUEUE_TABLE_CHECKBOX_CHECKED]: (state, { payload }) => {
    return {
      ...state,
      tableDropdownChecked: payload,
    };
  },
  [SET_TABLE_HEADER_DROPDOWN_VALUE]: (state, { payload }) => {
    return {
      ...state,
      tableHeaderDropdownValue: payload,
    };
  },
  [SET_SELECTED_ENTRIES]: (state, { payload }) => {
    return {
      ...state,
      selectedEntries: [...payload],
    };
  },
  [SET_DESELECTED_ENTRIES]: (state, { payload }) => {
    return {
      ...state,
      deselectedEntries: [...payload],
    };
  },
  [CLEAR_MONITORING_QUEUE_ENTRIES]: () => initialState,
  [SET_MONITORING_QUEUE_ENTRY_NO_ENTRIES_MESSAGE]: (state, { payload }) => {
    return {
      ...state,
      noEntriesMessage: payload,
    };
  },
});

export default monitoringQueueEntriesReducer;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/reducers/monitoringQueueEntriesReducer.js